import React from 'react';
import { motion } from 'framer-motion';
import { Play, Users, MessageCircle } from 'lucide-react';
export function IncluyeSection() {
  const features = [{
    icon: <Play className="w-8 h-8 text-brand-black" data-id="element-87" />,
    title: '3 clases pregrabadas',
    description: 'Aprendé a tu ritmo, cuando quieras. Contenido directo al grano sin relleno.'
  }, {
    icon: <Users className="w-8 h-8 text-brand-black" data-id="element-88" />,
    title: 'Reuniones semanales en vivo',
    description: 'Acompañamiento real, no estás solo. Resolvemos tus trabas específicas.'
  }, {
    icon: <MessageCircle className="w-8 h-8 text-brand-black" data-id="element-89" />,
    title: 'Comunidad privada en WhatsApp',
    description: 'Red de profesionales como vos. Networking, apoyo y respuestas rápidas.'
  }];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-90">
      <div className="max-w-5xl mx-auto" data-id="element-91">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.3
      }} className="text-center mb-16" data-id="element-92">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-brand-black mb-6" data-id="element-93">
            ¿Qué incluye el programa?
          </h2>
          <div className="w-24 h-1 bg-brand-orange mx-auto rounded-full" data-id="element-94"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16" data-id="element-95">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.25,
          delay: index * 0.08
        }} className="border-2 border-gray-100 rounded-2xl p-8 hover:border-brand-orange transition-colors group" data-id="element-96">
              <div className="bg-gray-100 w-16 h-16 rounded-full flex items-center justify-center mb-6 group-hover:bg-brand-orange transition-colors" data-id="element-97">
                {feature.icon}
              </div>
              <h3 className="text-xl font-heading font-bold text-brand-black mb-3" data-id="element-98">
                {feature.title}
              </h3>
              <p className="text-gray-600" data-id="element-99">{feature.description}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        delay: 0.15
      }} className="flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-100">
          <a href="#" className="w-full sm:w-auto bg-brand-orange text-brand-black font-bold text-lg px-10 py-4 rounded-xl shadow-lg hover:scale-[1.03] transition-transform text-center" data-id="element-101">
            Quiero acceder ahora
          </a>
          <a href="https://wa.me/5491100000000" className="w-full sm:w-auto text-brand-black font-medium hover:text-brand-orange transition-colors text-center underline underline-offset-4" data-id="element-102">
            Consultar antes de entrar
          </a>
        </motion.div>
      </div>
    </section>;
}